import React from "react"
import { withTheme } from "emotion-theming"
import { ResponsivePie } from "@nivo/pie"

import { counsellorHelp } from "@data/counsellor-help"

import { Wrapper } from "./styles"

const CounsellorHelp = ({ theme, legend }) => {
  return (
    <Wrapper height={legend ? "500px" : "250px"}>
      <ResponsivePie
        margin={legend ? { top: 40, bottom: 40, right: 200 } : {}}
        data={counsellorHelp}
        borderWidth={0}
        innerRadius={0.8}
        colors={[
          theme.colours.danger,
          theme.colours.warning,
          theme.colours.secondary,
          theme.colours.success,
          theme.colours.lightPrimary,
          theme.color,
        ]}
        enableRadialLabels={false}
        enableSlicesLabels={false}
        tooltip={props => (
          <span>
            <strong>{props.label}</strong> | {props.value}%
          </span>
        )}
        legends={
          legend
            ? [
                {
                  dataFrom: "keys",
                  anchor: "bottom-right",
                  direction: "column",
                  justify: false,
                  translateX: 200,
                  translateY: 0,
                  itemsSpacing: 2,
                  itemWidth: 200,
                  itemHeight: 20,
                  itemDirection: "left-to-right",
                  itemOpacity: 1,
                  symbolSize: 20,
                },
              ]
            : []
        }
      />
    </Wrapper>
  )
}

export default withTheme(CounsellorHelp)
